module.exports = __webpack_public_path__ + "media/images/favourited-88944e9e.png";